module.exports = __webpack_public_path__ + "assets/img/woman.02822459.png";